import * as API from '@common/api/app-resource'
import * as T from './types'

const actions = {

    // 业务对象分组
    [T.GET_NEW_OBJECT_GROUP]() {
        return API.getNewObjectGroup()
    },
    // 新增业务对象分组
    [T.ADD_NEW_OBJECT_GROUP](store, {
        params,
    }) {
        return API.addNewObjectGroup(params)
    },
    // 编辑业务对象分组
    [T.EDIT_NEW_OBJECT_GROUP](store, {
        groupId, params,
    }) {
        return API.editNewObjectGroup(groupId, params)
    },
    // 删除业务对象分组
    [T.DEL_NEW_OBJECT_GROUP](store, {
        groupId,
    }) {
        return API.delNewObjectGroup(groupId)
    },

    // 新业务对象
    [T.GET_NEW_OBJECT](store, params) {
        return API.getNewObject(params)
    },

    // 新业务对象
    [T.GET_BUSINESS_OBJECT](store, params) {
        return API.getBusinessObject(params)
    },

    // 系统务对象
    [T.GET_SYSTEM_OBJECT](store, params) {
        return API.getNewSystemObject(params)
    },
    
    // 新增业务对象
    [T.ADD_NEW_OBJECT](store, params) {
        return API.addNewObject(params)
    },
    // 编辑业务对象
    [T.EDIT_NEW_OBJECT](store, {
        objectId, params,
    }) {
        return API.editNewObject(objectId, params)
    },
    // 删除业务对象
    [T.DEL_NEW_OBJECT](store, {
        objectId,
    }) {
        return API.delNewObject(objectId)
    },
    // 查询业务对象详情
    [T.GET_NEW_OBJECT_DTL](store, {
        objectId,
    }) {
        return API.getNewObjectDtl(objectId)
    },
    // 批量创建业务对象
    [T.BATCH_CREATE_OBJECT](store, data) {
        return API.batchCreateObject(data)
    },
    [T.CHECK_CUSTOMIZE_FIELD](store, data) {
        const { appId } = data
        return API.checkCustomizeField(appId, data)
    },

    [T.GET_PURVIEW_OBJECT](store, payload) {
        return API.getPurviewObject(payload)
    },

    // 新业务对象字段
    [T.GET_NEW_OBJECT_FIELD](store, {
        objectId,
    }) {
        return API.getNewObjectField(objectId)
    },
    
    // 新增业务对象字段
    [T.ADD_NEW_OBJECT_FIELD](store, {
        objectId, params,
    }) {
        return API.addNewObjectField(objectId, params)
    },
    // 编辑业务对象字段
    [T.EDIT_NEW_OBJECT_FIELD](store, {
        objectId, fieldId, params,
    }) {
        return API.editNewObjectField(objectId, fieldId, params)
    },
    // 删除业务对象字段
    [T.DEL_NEW_OBJECT_FIELD](store, {
        objectId, fieldId,
    }) {
        return API.delNewObjectField(objectId, fieldId)
    },

    // 服务分组
    [T.GET_NEW_SERVICE_GROUP]() {
        return API.getNewServiceGroup()
    },
    // 新增服务分组
    [T.ADD_NEW_SERVICE_GROUP](store, params) {
        return API.addNewServiceGroup(params)
    },
    // 编辑服务分组
    [T.EDIT_NEW_SERVICE_GROUP](store, {
        groupId, params,
    }) {
        return API.editNewServiceGroup(groupId, params)
    },
    // 删除服务分组
    [T.DEL_NEW_SERVICE_GROUP](store, {
        groupId,
    }) {
        return API.delNewServiceGroup(groupId)
    },

    // 新服务
    [T.GET_NEW_SERVICE](store, payload) {
        return API.getNewService(payload)
    },
    // 新增服务
    [T.ADD_NEW_SERVICE](store, params) {
        return API.addNewService(params)
    },
    // 编辑服务
    [T.EDIT_NEW_SERVICE](store, {
        serviceId, params,
    }) {
        return API.editNewService(serviceId, params)
    },

    // 删除服务
    [T.DEL_NEW_SERVICE](store, {
        serviceId,
    }) {
        return API.delNewService(serviceId)
    },

    [T.GET_OBJECT_DETAIL](store, payload) {
        return API.getObjectDetail(payload).then(data => data)
    },

    // 导入对象
    [T.IMPORT_OBJECT](store, { webappId, params, workspaceId }) {
        return API.importObject(webappId, params, workspaceId)
    },
    // 导入服务
    [T.IMPORT_SERVICE](store, { webappId, params, workspaceId }) {
        return API.importService(webappId, params, workspaceId)
    },
    [T.GET_ENV_LIST](store, payload) {
        return API.getEnvList(payload).then(res => res)
    },
    // 关闭mock
    [T.CLOSE_MOCK]() {
        return API.closeMock()
    },

    // 服务编排模块
    // 获取编排分组
    [T.GET_SERVICE_ARRANGE_GROUP](store, {
        appId, workspaceId, params,
    }) {
        return API.getServiceArrangeGroup(appId, workspaceId, params)
    },
    // 新增服务分组
    [T.ADD_SERVICE_ARRANGE_GROUP](store, { appId, workspaceId, params }) {
        return API.addServiceArrangeGroup(appId, workspaceId, params)
    },
    // 编辑服务分组
    [T.EDIT_SERVICE_ARRANGE_GROUP](store, { appId, params, workspaceId }) {
        return API.editServiceArrangeGroup(appId, params, workspaceId)
    },
    // 获取编排服务
    [T.GET_SERVICE_ARRANGE](store, {
        appId, params, workspaceId,
    }) {
        return API.getServiceArrange(appId, params, workspaceId)
    },
    // 新增服务
    [T.ADD_SERVICE_ARRANGE](store, {
        appId, params, workspaceId,
    }) {
        return API.addServiceArrange(appId, params, workspaceId)
    },
    // 编辑服务
    [T.EDIT_SERVICE_ARRANGE](store, {
        appId, params, workspaceId,
    }) {
        return API.editServiceArrange(appId, params, workspaceId)
    },
    // 删除服务
    [T.DEL_SERVICE_ARRANGE](store, {
        appId, workspaceId, params,
    }) {
        return API.delServiceArrange(appId, workspaceId, params)
    },
    // 发布服务
    [T.PUBLISH_SERVICE_ARRANGE](store, {
        appId, workspaceId, params,
    }) {
        return API.publishServiceArrange(appId, workspaceId, params)
    },
    // 下线服务
    [T.OFFLINE_SERVICE_ARRANGE](store, {
        appId, workspaceId, params,
    }) {
        return API.offlineServiceArrange(appId, workspaceId, params)
    },
    // 登录服务
    [T.LOGIN_SERVICE_ARRANGE](store, {
        appId, workspaceId, params,
    }) {
        return API.loginServiceArrange(appId, workspaceId, params)
    },
    // 演示数据
    [T.GET_MOCK_LIST](store, params) {
        return API.getMockList(params)
    },
    [T.GET_MOCK_TEMPLATE](store, params) {
        return API.getMockTemplate(params)
    },
    [T.DELETE_MOCK_ITEM](store, id) {
        return API.deleteMockItem(id)
    },
    [T.CREATE_MOCK_OBJECT](store, params) {
        return API.createMockObject(params)
    },
    [T.UPLOAD_MOCK_EXCELL](store, params) {
        return API.uploadMockExcell(params)
    },
    [T.UPDATE_MOCK_EXCELL](store, params) {
        return API.updateMockExcell(params)
    },
    [T.GET_OBJECT_FIELD](store, params) {
        return API.getObjectField(params)
    },

}

export default actions
